/**
 * Utilities class. 
 * This is a singleton class.
 */
const Utils = (function () {
    const queryParamMap = new WeakMap();

    return new class Utils {
        constructor() { }

        getCookie(name) {
            let matches = document.cookie.match(new RegExp(
                "(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + "=([^;]*)"
            ));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        }

        calcOutline(color) {
            let c = new THREE.Color(color);
            let lum = 0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b;
            let outlineC;

            if (lum < 0.5) { outlineC = "#fff" }
            else { outlineC = "#000"; }

            return "1px 0 1px " + outlineC + ", -1px 0 1px " + outlineC + ", 0 1px 1px " + outlineC + ", 0 -1px 1px " + outlineC;
        }

        /**
         * Default query params getter.
         * @returns {QueryParams} Query.
         */
        get queryParams() { return this.getQueryParams(); }

        /**
         * Gets query parameters from the browser.
         * @param {Window} Window context to run on.
         * @returns {QueryParams} Query.
         */
        getQueryParams(_window = window) {
            let queryParams = queryParamMap.get(_window);

            if (queryParams) return queryParams;

            queryParams = initQueryParams(_window);
            queryParamMap.set(_window, queryParams);

            return queryParams;
        }

        getFormattedDate(defDate = null) {
            let date = (defDate)? new Date(defDate) : new Date();
            
            let year = date.getFullYear();
            let month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : '0' + month;
            let day = date.getDate().toString();
            day = day.length > 1 ? day : '0' + day;
    
            return day + '.' + month + '.' + year;
        }

        secondsToString(sec, displayHours) {
            sec = Math.round(sec);
            let hh = Math.floor(sec / 3600);
            let mm = Math.floor((sec - (hh * 3600)) / 60);
            let ss = sec - (hh * 3600) - (mm * 60);

            if (hh === 0 && !displayHours) { hh = ""; } else {
                if (hh < 10) { hh = "0" + hh; }

                hh = hh + ":";
            }

            if (mm < 10) { mm = "0" + mm; }

            mm = mm + ":";

            if (ss < 10) { ss = "0" + ss; }

            return hh + mm + ss;
        }

        hexToComplimentary(hex) {

            // Convert hex to rgb
            // Credit to Denis http://stackoverflow.com/a/36253499/4939630
            let rgb = 'rgb(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')).map(function (l) { return parseInt(hex.length % 2 ? l + l : l, 16); }).join(',') + ')';

            // Get array of RGB values
            rgb = rgb.replace(/[^\d,]/g, '').split(',');

            let r = rgb[0], g = rgb[1], b = rgb[2];

            // Convert RGB to HSL
            // Adapted from answer by 0x000f http://stackoverflow.com/a/34946092/4939630
            r /= 255.0;
            g /= 255.0;
            b /= 255.0;
            let max = Math.max(r, g, b);
            let min = Math.min(r, g, b);
            let h, s, l = (max + min) / 2.0;

            if (max == min) {
                h = s = 0;  //achromatic
            } else {
                let d = max - min;
                s = (l > 0.5 ? d / (2.0 - max - min) : d / (max + min));

                if (max == r && g >= b) {
                    h = 1.0472 * (g - b) / d;
                } else if (max == r && g < b) {
                    h = 1.0472 * (g - b) / d + 6.2832;
                } else if (max == g) {
                    h = 1.0472 * (b - r) / d + 2.0944;
                } else if (max == b) {
                    h = 1.0472 * (r - g) / d + 4.1888;
                }
            }

            h = h / 6.2832 * 360.0 + 0;

            // Shift hue to opposite side of wheel and convert to [0-1] value
            h += 180;
            if (h > 360) { h -= 360; }
            h /= 360;

            l = 1.0 - l

            if (s < 0.5)
                s += 0.5

            // Convert h s and l values into r g and b values
            // Adapted from answer by Mohsen http://stackoverflow.com/a/9493060/4939630
            if (s === 0) {
                r = g = b = l; // achromatic
            } else {
                let hue2rgb = function hue2rgb(p, q, t) {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 1 / 2) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                };

                let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                let p = 2 * l - q;

                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }

            r = Math.round(r * 255);
            g = Math.round(g * 255);
            b = Math.round(b * 255);

            // Convert r b and g values to hex
            rgb = b | (g << 8) | (r << 16);
            return "#" + (0x1000000 | rgb).toString(16).substring(1);
        }

        rgbToHex(rgb) {
            let rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
            let result, r, g, b, hex = "";
            if ((result = rgbRegex.exec(rgb))) {
                r = componentFromStr(result[1], result[2]);
                g = componentFromStr(result[3], result[4]);
                b = componentFromStr(result[5], result[6]);

                hex = "#" + (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1);
            }
            return hex;
        }

        isMobile = {
            Android: () => {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: () => {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: () => {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: () => {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: () => {
                return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
            },
            any: () => {
                return (this.isMobile.Android() || this.isMobile.BlackBerry() || this.isMobile.iOS() || this.isMobile.Opera() || this.isMobile.Windows());
            }
        }

        downloadSource() {
            const pr = new Promise((resolve, reject) => {
              let data = Q3.selected.data;
              let src = data.originalSrc ? Q3.s3Url + data.originalSrc :  Q3.s3Url + data.src;
              if(data.amp_variation){
                let ampUrl = "https://amp-api.embibe.com";
                $.get(`${ampUrl}/variants/${data.amp_variation}`).then((res) => {
                  if (res.ready_links[0]?.url){
                    resolve(res.ready_links[0].url)
                  }
                });
              }else{resolve(src)}
            });
        
            pr.then(src => {
              saveAs(src, Q3.selected.parentLayer.name);
            })
          }
    }
})();

export default Utils;
export { Utils };

function componentFromStr(numStr, percent) {
    let num = Math.max(0, parseInt(numStr, 10));
    return percent ?
        Math.floor(255 * Math.min(100, num) / 100) : Math.min(255, num);
}

function initQueryParams(_window) {
    let match;
    const pl = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = s => { return decodeURIComponent(s.replace(pl, " ")); },
        query = _window.location.search.substring(1);

    const values = {};

    while (match = search.exec(query))
        values[decode(match[1])] = decode(match[2]);

    Object.freeze(values);

    return new class QueryParams {
        constructor() { }

        get values() { return values; }

        has(param) {
            return values[param] !== undefined &&
                values[param] !== "false" && values[param] !== 0;
        }

        remove(param) {
            window.history.replaceState({}, document.title, window.location.origin + window.location.pathname + "?" + window.location.search.slice(1).split("&").filter(q => q.indexOf(param) !== 0).join("&"));
        }

        get(param) { return values[param] || null; }
        getInt(param) { return parseInt(values[param]); }
        getNumber(param) { return parseFloat(values[param]); }
    }
};

/**
 * @typedef QueryParams
 * @property {Object} values
 * @property {function} has
 * @property {function} getInt
 * @property {function} getNumber
 */